import './Research.scss';
import Heading from '../../sharedComponents/Heading/Heading';
import ResearchImage from '../../../assets/ResearchImage.svg';
import Button from '../../sharedComponents/Button/Button';
import { useNavigate } from 'react-router-dom';
function Research() {
    let navigate = useNavigate();

    const goToResearchPage = () => {
        window.scrollTo(0, 0);
        navigate("/research");
    }
    return (
        <div id='alpha-perceptron-research' className='alpha-perceptron-research responsiveFlexBox'>
            <div className='alpha-perceptron-research__container responsiveFlexBox'>
            <div className='alpha-perceptron-research__container__text-container'>
            <Heading size='h2' type='tertiary'>
                Research & Innovation
            </Heading>
            <Heading size='h6' type='tertiary'>
                Exploring the frontiers of artificial intelligence—our work spans self-learning systems, next-gen
                automation, and cognitive computing.
            </Heading>
            <Button onClick={goToResearchPage} type='secondary' theme='dark'>Learn More</Button>
            </div>
            <img src={ResearchImage} alt='Research & Inovation' />
            </div>
        </div>
    );
}

export default Research;

